import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/id';

dayjs.extend(duration);
dayjs.locale('id');

const ExpiredDay = ({ expiredDate }) => {
    const [remaining, setRemaining] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            const now = dayjs();
            const target = dayjs(expiredDate);
            const diff = target.diff(now);

            if (diff <= 0) {
                setRemaining('Waktu telah habis');
                clearInterval(interval);
                return;
            }

            const dur = dayjs.duration(diff);
            const hours = dur.hours().toString().padStart(2, '0');
            const minutes = dur.minutes().toString().padStart(2, '0');
            const seconds = dur.seconds().toString().padStart(2, '0');

            setRemaining(`${hours} jam ${minutes} menit ${seconds} detik`);
        }, 1000);

        return () => clearInterval(interval);
    }, [expiredDate]);

    const formattedDeadline = dayjs(expiredDate).format('DD MMMM YYYY HH:mm');

    return (
        <div>
            <p className='text-danger'>{remaining}</p>
            <p>Jatuh tempo {formattedDeadline}</p>
        </div>
    );
};

export default ExpiredDay;
